// The drawer the notification center opens in (APP_SHELL.md: "Notification
// center … drawers"): from the right on tablet and desktop, a sheet from the
// bottom on a phone, over the current screen — tapping a row is what leaves
// it. PLAN-2026-09-26-bell B2. The panel is the kit's.

import { SidePanel } from '../kit/overlays';
import { useNotifications } from '../data/notifications';
import { NotificationCenter } from './NotificationCenter';

export function NotificationDrawer() {
  const { open, setOpen } = useNotifications();
  return (
    <SidePanel
      opened={open}
      onClose={() => setOpen(false)}
      title="Notifications"
      closeLabel="Close notifications"
    >
      <NotificationCenter />
    </SidePanel>
  );
}
